import React, { useState } from "react";
import { Link } from "react-router-dom";
import Menu from "./hamburger";

export default function Navbar() {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const toggleHamburger = () => {
    setHamburgerOpen(!hamburgerOpen);
  };
  return (
    <div className="nav">
      <div>
        <Link to="/home" className="logo">
          {" "}
          devolayinka
        </Link>
      </div>
      <div className="navlinks">
        <ul>
          <li>
            <Link to="/home" className="heading">
              {" "}
              Home
            </Link>{" "}
          </li>

          <li>
            <a href="https://olayinka-portfolio.netlify.app/" target="new">
              Portfolio
            </a>
          </li>
          <li>
            <Link to="/search" className="heading">
              {" "}
              repo
            </Link>
          </li>
          <li>
            <Link to="/error" className="heading">
              {" "}
              Error Page
            </Link>
          </li>
        </ul>
        <div className="menu-tab" onClick={toggleHamburger}>
          <Menu isOpen={hamburgerOpen} />
        </div>
      </div>
      <style jsx="true">
        {`
        .nav{
          display:flex;
          align-content:center;
          align-items:center;
          justify-content:space-between;
          color:rgb(247, 245, 245);
  background:rgb(1, 1, 12);
  padding:10px;
        }
    .navlinks{
     width:100%;
     height:50px;
    }
.navlinks ul{
      margin-top:15px;
      gap:60px;
      padding-right:20px;
    float:right;
    display:flex;
    }
 
    .logo,.heading,a{
      color:white;
    
    }
    .navlinks ul li{
        list-style-type:none!important;
    }
    .navlinks ul li a,.logo{
       text-decoration:none;
       text-transform:capitalize;
    }
    .navlinks ul li a:hover{
      text-decoration:underline;
    }
    .menu-tab{
      display:none;
      z-index:6;
    }
    @media(max-width:767px){
    section{
      padding:10px;
    }
    nav{
      margin-bottom:40px;
    }
     .menu-tab{
        display:flex;
        flex-diection:row;
        z-index:100;
        color:white;
        position:absolute;
        top:14px;
        right:20px;
      }
     
      .navlinks ul{
        display: ${hamburgerOpen ? "inline" : "none"};
        background-color: white;
        height: 100vh;
        width: 100%;
        margin-top: 80px;
        position: fixed;
        left:20px;
        text-align:center;
        border-top-left-radius: 10px; 
      
      }
      .navlinks ul li{
        margin-top:90px;
       
      }
     .heading, a{
        color:#000;
        font-weight:500;
        font-size:1.1rem;
        margin-top:30px;
  
     }
    }
    `}
      </style>
    </div>
  );
}
